import { render, staticRenderFns } from "./add-originality.vue?vue&type=template&id=2c749148&scoped=true&"
import script from "./add-originality.vue?vue&type=script&lang=js&"
export * from "./add-originality.vue?vue&type=script&lang=js&"
import style0 from "./add-originality.vue?vue&type=style&index=0&id=2c749148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c749148",
  null
  
)

export default component.exports